import React from 'react';
import ReactECharts from 'echarts-for-react';
import { Card, CardContent, Typography, Grid } from '@mui/material';
import { TrendingUp, Users, CheckCircle, AlertTriangle } from 'lucide-react';

export const ExecutiveDashboard: React.FC = () => {
  const chartOption = {
    title: { text: 'IEP Goal Completion Trajectory (2026)', left: 'center' },
    tooltip: { trigger: 'axis' },
    xAxis: { type: 'category', data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'] },
    yAxis: { type: 'value', name: 'Success %' },
    series: [
      {
        name: 'Target Progress',
        type: 'line',
        data: [20, 35, 50, 65, 75, 85, 92],
        smooth: true,
        itemStyle: { color: '#1976d2' }
      },
      {
        name: 'Actual Progress',
        type: 'line',
        data: [18, 30, 48, 60, 72, 80, 88],
        smooth: true,
        itemStyle: { color: '#00796b' }
      }
    ]
  };

  return (
    <div className="space-y-6">
      <div>
        <Typography variant="h4" className="font-extrabold text-slate-800">
          Executive C-Suite Command Center
        </Typography>
        <Typography variant="body2" className="text-slate-500">
          Real-time Organization Outcome Metrics & Student Risk Matrix
        </Typography>
      </div>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={3}>
          <Card className="border border-slate-200">
            <CardContent className="flex items-center gap-4">
              <Users className="w-10 h-10 text-blue-600" />
              <div>
                <Typography variant="subtitle2" className="text-slate-500">Enrolled Students</Typography>
                <Typography variant="h4" className="font-bold">1,420</Typography>
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Card className="border border-slate-200">
            <CardContent className="flex items-center gap-4">
              <TrendingUp className="w-10 h-10 text-emerald-600" />
              <div>
                <Typography variant="subtitle2" className="text-slate-500">IEP Goal Success Rate</Typography>
                <Typography variant="h4" className="font-bold">88.4%</Typography>
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Card className="border border-slate-200">
            <CardContent className="flex items-center gap-4">
              <CheckCircle className="w-10 h-10 text-purple-600" />
              <div>
                <Typography variant="subtitle2" className="text-slate-500">Therapy Sessions Logged</Typography>
                <Typography variant="h4" className="font-bold">12,450</Typography>
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Card className="border border-slate-200">
            <CardContent className="flex items-center gap-4">
              <AlertTriangle className="w-10 h-10 text-amber-600" />
              <div>
                <Typography variant="subtitle2" className="text-slate-500">High-Risk Students</Typography>
                <Typography variant="h4" className="font-bold">35</Typography>
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Apache ECharts Chart Wrapper */}
      <Card className="border border-slate-200 p-4">
        <ReactECharts option={chartOption} style={{ height: '350px' }} />
      </Card>
    </div>
  );
};
